import {Injectable} from "@angular/core";
import {AbstractProdSelectService, IProdSelectProperties} from 'prod-select';
import {IProdFormService} from 'prod-form';
import {Observable} from "rxjs";
import {IProdGridService} from 'prod-grid';
import {HttpExtraParams} from "prod-shared";
import {Help} from "../models/help";

@Injectable({
  providedIn: 'root'
})

export class HelpService extends AbstractProdSelectService implements IProdFormService, IProdGridService {
  override selectDataUrl: string = 'helps';
  override selectProperties: IProdSelectProperties = {
    id: 'id',
    name: 'nationality.code',
    extraProperties: [{
      name: '',
      value: 'nationality.country'
    }]
  };

  getProdGridData(params?: HttpExtraParams): Observable<Object> {
    return this.httpClient.get<{ data: { result: Help[], totalCount: number }, success: boolean }>(`/api/helps`, {params});
  }

  prodGridAdd(values: any): Observable<Object> {
    return this.httpClient.post(`/api/help`, values);
  }

  prodGridPatch(values: any, id: number): Observable<Object> {
    return this.httpClient.patch(`/api/help/${id}`, values);
  }

  prodGridRemove(id: number): Observable<Object> {
    throw new Error("Method not implemented.");
  }
}
